
import { BaseService } from './BaseService';

export class TokenService extends BaseService {

    public revokeTokenAsync = async (accessToken: string) => {
        return await this.getResponseAsync<void>(
            {
                commandPath: `token/revoke`,
                method: 'POST',
            },
            accessToken,
        );
    }
}